import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7f0105c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "group"
}
const _hoisted_2 = { class: "editable-list" }
const _hoisted_3 = {
  key: 0,
  class: "group"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "shape-inputs" }
const _hoisted_6 = { key: 0 }

import { useStore } from 'vuex';
import CutoutPosition from './CutoutPosition.vue';
import CutoutType from './CutoutType.vue';
import ShapeType from './ShapeType.vue';
import ValidationMessage from './UI/ValidationMessage.vue';
import {computed, ref, Ref, watch} from 'vue';
import EditableItem from './EditableItem.vue';
import MeasurementsHeightTransition from './UI/MeasurementsHeightTransition.vue';
import {getCurrentShapeInputComponent} from "@/components/shapes/ShapeHelper";
import { renderLength } from '@/functions/lengths';
import MessageContainer from "@/components/UI/MessageContainer.vue";
import { CutoutTypes } from '@/Models/CutoutTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'CutoutsConfiguration',
  setup(__props) {

const store = useStore();

const isEditorVisible = ref<boolean>(true);
const isAddingCutout = ref<boolean>(false);
const isEditingExistingCutout = ref<boolean>(false);
const containerRef = ref<HTMLElement | null>(null);

const cutoutType = computed(() => store.getters.cutoutType);
const cutoutShape = computed(() => store.getters.cutoutShape);
const canUseExactCenter = computed(() => store.getters.canUseExactCenter);
const hasProblematicCorners = computed(() => store.getters.hasProblematicCorners);
const usesDefaultCutoutDimensions = computed(() => store.getters.usesDefaultCutoutDimensions);
const cutouts = computed(() => store.getters.cutouts);
const cutout = computed(() => store.getters.cutout);
const currentCutoutIndex = computed(() => store.getters.currentCutoutIndex);
const hasGroupedDimensionValidatorErrors = computed(() => store.getters.hasGroupedCutoutValidatorErrors);
const getGroupedDimensionValidationMessage = computed(() => store.getters.getGroupedCutoutValidationMessage);
const validationDimensionMessages = computed(() => {
	const validators = store.getters.getCutoutValidatorErrors;
	const excludedFields = ['cutoutOffset', 'cutoutOffsetLeft', 'cutoutOffsetBottom'];
	const filteredValidators = [...validators].filter((validator) => !excludedFields.includes(validator.field));

	return filteredValidators.map((validator) => {
		return {
			key: validator.field,
			id: `measurements-${validator.field}`,
			message: validator.getMessage(),
		};
	});
});

watch(cutout, async(newValue, oldValue) => {

	// Set the default cutout
	if (newValue && cutouts.value.length === 0) {
		store.commit("addCutout", newValue);
		editCutout(0);
	}

	// Update current cutout
	if(newValue != oldValue && newValue != null) {
		store.commit("updateCutoutByIndex", { index: currentCutoutIndex.value, cutout: newValue });
	}
});

// Add cutout when shape is selected
watch(cutoutShape, async(newValue, oldValue) => {
	if(newValue === '') {
		return;
	}

	if (newValue !== oldValue && isAddingCutout.value) {
		store.commit('updateCutoutIndex', store.getters.cutouts.length );
		store.commit('addCutout', store.getters.cutout );
	}

	isAddingCutout.value = false;
});

const isMaxSafeCutoutReached = computed(() => {
	const maxSafeCutoutPercentage = window.measurementSelectorVariables.pricingGroup.other_settings.max_safe_cutout_percentage;

	if ( store.getters.cutout === null || store.getters.getCutoutArea === 0 || store.getters.getShapeArea === 0 || maxSafeCutoutPercentage == 0 ) {
		return false;
	}

	return ( store.getters.getCutoutArea / store.getters.getShapeArea ) * 100 > maxSafeCutoutPercentage;
});

const currentProps = computed( () => {
	return {
		isCutout: true,
		action: "updateCutoutDimension",
		prefix: "cutout_",
		modifierAction: "updateCutoutModifier",
	};
} );

async function addCutout(): Promise<void> {
	isEditorVisible.value = true;
	isEditingExistingCutout.value = false;
	isAddingCutout.value = true;

	if (cutoutType.value === CutoutTypes.text) {

		// cutoutShape doesn't change for text, so we can update the cutout directly
		store.commit('updateCutoutIndex', cutouts.value.length );
		store.commit('addCutout', cutout.value );
	} else {

		// Start with a empty cutout, add after shape is selected
		await store.dispatch('resetCutoutShapeAndDimension', '');
	}
}

function saveCutout(): void {
	isEditorVisible.value = false;
	scrollTo(containerRef);

	if ( !isEditingExistingCutout.value ) {
		store.commit('updateCutoutIndex', -1);
		store.commit('updateUsingDefaultCutoutDimensions', true);

		return;
	}

	store.commit('updateCutoutByIndex', { index: currentCutoutIndex.value, cutout: cutout.value } );
	store.commit('updateCutoutIndex', -1);
}

function editCutout(index: number): void {
	isEditorVisible.value = true;
	isEditingExistingCutout.value = true;

	store.commit('updateCutoutIndex', index );
	store.dispatch('updateCurrentCutout');
}

function removeCutout(index: number): void {
	isEditorVisible.value = false;
	store.dispatch('removeCutout', index);
}

function scrollTo(view: Ref<HTMLElement | null>) {
	view.value?.scrollIntoView({ behavior: 'smooth' });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cutouts-container",
    ref_key: "containerRef",
    ref: containerRef
  }, [
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createVNode(CutoutType)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (cutouts.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cutouts.value, (cutout, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: _normalizeClass({
							"editable-list__item": true,
							"editable-list__item--active": currentCutoutIndex.value === index && isEditorVisible.value
						}),
                    key: index
                  }, [
                    _createVNode(EditableItem, {
                      edit: { index, title: _ctx.$i18n.cutout.edit, disabled: false, onClick: editCutout, hidden: currentCutoutIndex.value !== index && isEditorVisible.value },
                      remove: { index, title: _ctx.$i18n.cutout.remove, disabled: false, onClick: removeCutout, hidden: false }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$i18n.cutout.title) + " " + _toDisplayString(index + 1) + " - ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$i18n.shapeNames[cutout.shape]) + " | X - " + _toDisplayString(_unref(renderLength)(cutout.offsets[0].in_cm())) + " | Y - " + _toDisplayString(_unref(renderLength)(cutout.offsets[1].in_cm())), 1)
                      ]),
                      _: 2
                    }, 1032, ["edit", "remove"])
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MeasurementsHeightTransition, {
      appear: "",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (cutoutType.value !== 'none' && isEditorVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (cutoutType.value === 'shape')
                ? (_openBlock(), _createBlock(ShapeType, {
                    key: 0,
                    disabledShapes: ['dxf', 'text'],
                    storeShapeGetter: 'cutoutShape',
                    storeShapeUpdater: 'resetCutoutShapeAndDimension',
                    "is-cutout": true
                  }))
                : _createCommentVNode("", true),
              (cutoutShape.value !== '' && cutoutShape.value !== 'dxf')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getCurrentShapeInputComponent)(cutoutShape.value)), _normalizeProps(_guardReactiveProps(currentProps.value)), null, 16))
                    ]),
                    _createVNode(MessageContainer, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationDimensionMessages.value, (field) => {
                          return (_openBlock(), _createBlock(ValidationMessage, {
                            key: field.key + '-validation-message',
                            "input-id": field.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(field.message), 1)
                            ]),
                            _: 2
                          }, 1032, ["input-id"]))
                        }), 128)),
                        (hasGroupedDimensionValidatorErrors.value)
                          ? (_openBlock(), _createBlock(ValidationMessage, {
                              key: 0,
                              "input-id": "grouped-validation-message"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(getGroupedDimensionValidationMessage.value), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (cutoutShape.value !== '')
                ? (_openBlock(), _createBlock(CutoutPosition, { key: 2 }))
                : _createCommentVNode("", true),
              (cutoutShape.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    onClick: saveCutout,
                    class: "measurements-selector__button-add measurements-selector__button-add--block",
                    type: "button"
                  }, _toDisplayString(_ctx.$i18n.cutout.save), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(MessageContainer, null, {
      default: _withCtx(() => [
        (isMaxSafeCutoutReached.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 0,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.largeCutoutNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (canUseExactCenter.value === false && usesDefaultCutoutDimensions.value === true)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 1,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.centerOfShapeNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (hasProblematicCorners.value)
          ? (_openBlock(), _createBlock(ValidationMessage, {
              key: 2,
              type: "notice"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$i18n.problematicCornersNotice), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (cutoutType.value !== 'none' && !isEditorVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: addCutout,
            class: "measurements-selector__button-add",
            type: "button"
          }, _toDisplayString(_ctx.$i18n.cutout.add), 1)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})